import type { AudioController } from "./audio";
import type { InputController } from "./input";

export const LOGICAL_WIDTH = 1280;
export const LOGICAL_HEIGHT = 720;

export type InputAction =
  | "left"
  | "right"
  | "up"
  | "down"
  | "primary"
  | "secondary";

export interface GameHud {
  readonly score: number;
  readonly time: number;
  readonly message: string;
  readonly ended: boolean;
}

export interface GameServices {
  readonly input: InputController;
  readonly audio: AudioController;
  readonly announce: (message: string) => void;
  readonly reducedMotion: boolean;
}

export interface GameInstance {
  advanceTime(deltaSeconds: number): void;
  update(deltaSeconds: number): void;
  render(context: CanvasRenderingContext2D): void;
  getHud(): GameHud;
  destroy(): void;
}

export type GameFactory = (services: GameServices) => GameInstance;
